//@flow
import { HiverAxios, setHiddenLoadingBar, showMessage } from 'h-commons';
import values from 'lodash/values';
import {
    SYNC_GSUITE_USERS_DONE,
    SYNC_GSUITE_USERS_INIT,
    SYNC_GSUITE_USERS_FAILED,
    SYNC_GSUITE_GROUPS_DONE,
    SYNC_GSUITE_GROUPS_INIT,
    SYNC_GSUITE_GROUPS_FAILED
} from './types';
export const syncGSuite = (groups: boolean, hidden: boolean) => (dispatch: Function) => {
    dispatch({
        type: groups ? SYNC_GSUITE_GROUPS_INIT :SYNC_GSUITE_USERS_INIT
    });
    hidden && dispatch(setHiddenLoadingBar(true));
    HiverAxios({
        url: `/api/settings/users/marketplace/sync${ groups ? '?groups=1': ''}`,
        type: 'GET',
        callback: response => {
            if (response.data && response.data.success) {
                const data = groups ? values(response.data.data).map(v => v[0]) : response.data.data;
                showMessage({message: response.data.message, type: 'success'});
                dispatch({
                    type: groups ? SYNC_GSUITE_GROUPS_DONE : SYNC_GSUITE_USERS_DONE,
                    payload: data
                });
            } else
                dispatch({
                    type:  groups ? SYNC_GSUITE_GROUPS_FAILED : SYNC_GSUITE_USERS_FAILED,
                });
            hidden && dispatch(setHiddenLoadingBar(false));
        },
        onfail: () => {
            dispatch({
                type:  groups ? SYNC_GSUITE_GROUPS_FAILED : SYNC_GSUITE_USERS_FAILED,
            });
            hidden && dispatch(setHiddenLoadingBar(false));
        }
    });
}